import React, { forwardRef } from "react";
import { Button } from '@material-tailwind/react';
import "./Concert.css";

const Concert = () => {
  return (
    <div id="concert">
      <div className="md:mt-10 w-full flex flex-col md:px-20 space-y-4 md:space-x-0 md:space-y-0 md:items-center">
        <div className="text-white relative px-4 md:px-0 md:pt-20">
          <h1 className="text-2xl md:text-4xl mb-4 font-black">
            More Than Just  Music
          </h1>
          <div className="w-full">
            <img
              src={require("../../Assets/TMC-poster.png")}
              className="object-cover hidden md:block"
              alt="camp"
            />
            <img
              src={require("../../Assets/MoreThanMusicMobile.png")}
              className="object-cover md:hidden"
              alt="camp"
            />
          </div>
        </div>
        <div className="font-normal px-4 text-lg text-white relative pt-0 md:pt-32 text-center">
          <p>With a diverse lineup of artists from various backgrounds, the celebration fosters a strong sense of community and camaraderie – attendees come together in perfect rhythm, sharing the joy of music and forging enduring memories. </p>

          <br className="hidden md:block" />

          <p className="hidden md:block">The event features stages of varying sizes, showcasing pulsating beats, mesmerising melodies, and boundless energy. It transcends beyond a mere concert; it is an unparalleled experience that celebrates the beauty of music and its power to bring people together. Get ready to be enthralled as the campus comes alive with euphoria, uniting everyone in harmonious bliss. </p>

          <br className="hidden md:block" />

          <p className="hidden md:block">More Than Just Music is an immersive 2-day event, where Taylor's University Lakeside Campus will be transformed into a captivating campus-wide music festival. Tickets are required for Day 2 access and can be purchased using the button below.</p>

          <div className="text-center w-full">
            <a 
              href="https://tmc.quintagen.com/"
              target="_blank"
              className="text-cyan-500"
              rel="noreferrer"
            >
              <Button variant="outlined" style={{ color: '#D1597A' }} className="hidden md:inline-block bg-white px-16 mt-10 md:mt-20 text-2xl md:text-4xl font-black">
                Buy Tickets
              </Button>
              <Button variant="filled" className="md:hidden bg-white text-black px-16 border-2 md:border-4 mt-10 md:mt-20 text-2xl md:text-4xl font-black">
                Buy Tickets
              </Button>
            </a>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default forwardRef(Concert);
